// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected-providers{display:flex;align-items:center;flex-wrap:wrap;min-width:0;margin-bottom:-0.5rem}.selected-providers__label{flex:none;padding-right:1rem;margin-bottom:.5rem}.selected-providers__providers{flex:0 1 auto;min-width:0;display:flex;flex-wrap:wrap}.selected-providers__none{margin-bottom:.5rem}", ""]);
// Exports
module.exports = exports;
